import { promptConstants } from '../_constants';
import { promptService } from '../_services';
import { alertActions } from '.';

export const promptActions = {
  register,
  getById,
  getAll,
  getPlainList,
  update,
  delete: _delete,
};

function getById(id) {

  return dispatch => {
    dispatch(request({ id }));

    promptService.getById(id)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response))
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(id) { return { type: promptConstants.GET_REQUEST, id } }
  function success(prompt) { return { type: promptConstants.GET_SUCCESS, prompt } }
  function failure(error) { return { type: promptConstants.GET_FAILURE, error } }
}

function register(prompt) {
  return dispatch => {
    dispatch(request(prompt));

    promptService.register(prompt)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response));
            dispatch(alertActions.success('Prompt registration successful'));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(prompt) { return { type: promptConstants.REGISTER_REQUEST, prompt } }
  function success(prompt) { return { type: promptConstants.REGISTER_SUCCESS, prompt } }
  function failure(error) { return { type: promptConstants.REGISTER_FAILURE, error } }
}

function update(prompt) {
  return dispatch => {
    dispatch(request(prompt));

    promptService.update(prompt)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response));
            dispatch(alertActions.success('Prompt update successful'));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(prompt) { return { type: promptConstants.REGISTER_REQUEST, prompt } }
  function success(prompt) { return { type: promptConstants.REGISTER_SUCCESS, prompt } }
  function failure(error) { return { type: promptConstants.REGISTER_FAILURE, error } }
}

function getAll(api_params) {
  return dispatch => {
    dispatch(request());

    promptService.getAll(api_params)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response))
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response))
          }
        }
      );
  };

  function request() { return { type: promptConstants.GETALL_REQUEST } }
  function success(prompts) { return { type: promptConstants.GETALL_SUCCESS, prompts } }
  function failure(error) { return { type: promptConstants.GETALL_FAILURE, error } }
}

function getPlainList(api_params) {
  return dispatch => {
    dispatch(request());

    promptService.getPlainList(api_params)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response))
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response))
          }
        }
      );
  };

  function request() { return { type: promptConstants.GETALL_REQUEST } }
  function success(prompts) { return { type: promptConstants.GETALL_SUCCESS, prompts } }
  function failure(error) { return { type: promptConstants.GETALL_FAILURE, error } }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  return dispatch => {
    dispatch(request(id));

    promptService.delete(id)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(id));
            dispatch(alertActions.success('Prompt deleted successfully'));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(id, response));
          }
        }
      );
  };

  function request(id) { return { type: promptConstants.DELETE_REQUEST, id } }
  function success(id) { return { type: promptConstants.DELETE_SUCCESS, id } }
  function failure(id, error) { return { type: promptConstants.DELETE_FAILURE, id, error } }
}